import { render } from "./CardMarks.vue?vue&type=template&id=1e75c3eb&scoped=true&ts=true"
import script from "./CardMarks.vue?vue&type=script&lang=ts"
export * from "./CardMarks.vue?vue&type=script&lang=ts"

import "./CardMarks.vue?vue&type=style&index=0&id=1e75c3eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e75c3eb"]])

export default __exports__